import { combineReducers } from 'redux';
import loadingVersion from './loadingVersionReducer';
import totalCount from './totalCountReducer';
import selectedIds from './selectedIdsReducer';
import selectedSearchConditions from './selectedSearchConditionsReducer';
import params from './paramsReducer';
import items from './itemsReducer';
import item from './itemReducer';
import refreshVersion from './refreshVersionReducer';
import rest from './restReducer';

export default combineReducers({
    loadingVersion,
    totalCount,
    selectedIds,
    selectedSearchConditions,
    params,
    items,
    item,
    refreshVersion,
    rest
});